import request from '../helpers/request';

const updateWarrantyInfo = async (requestId, data) => {
  return await request.put(
    `/Warranty/info/${requestId}`,
    data,
    'Не удалось изменить подрядчика'
  );
};

export default updateWarrantyInfo;
